import { useEffect } from 'react'
import { useWalletClient } from 'wagmi'
import { AddressInfo, ConnectManager, SdkProvider, Trace, WalletConnect } from 'gby-sdk'
import { BrowserProvider } from 'ethers6'
import { ChainType } from 'gby-sdk/dist/service'
import { IS_PROD } from 'config'
import { mantle, mantleTestnet } from '@pancakeswap/address-config'
import { WalletClient } from 'viem'
import { useActiveChainId } from 'hooks/useActiveChainId'

Trace.setDebugShow(false)
Trace.setLogShow(false)
SdkProvider.initConfig(IS_PROD ? 'prod' : 'test')
SdkProvider.fastSetChainType(ChainType.hemi)

function updateInitConfig(env: string) {
  const config: AddressInfo = SdkProvider.getConfig()
  if (config.env !== env) {
    SdkProvider.initConfig(env as any)
  }
}

function updateAccount(walletClient: WalletClient) {
  const { chain, transport } = walletClient
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  }
  const provider = new BrowserProvider(transport as any, network)
  ConnectManager.connect(new WalletConnect(provider, provider))
  // console.log('updateAccount', walletClient.account.address)
}

function disConnect() {
  if (SdkProvider.checkConnect()) {
    try {
      SdkProvider.disconnect()
      // console.log('disconnect')
    } catch (e) {
      console.error(e)
    }
  }
}

function useGBYSDK() {
  const { data: walletClient } = useWalletClient()
  const { chainId } = useActiveChainId()
  useEffect(() => {
    if (chainId === mantleTestnet.id) {
      updateInitConfig('test')
      disConnect()
    }
    if (chainId === mantle.id) {
      disConnect()
      updateInitConfig('prod')
    }
    if (!walletClient) {
      disConnect()
      return
    }
    if (SdkProvider.checkConnect()) {
      if (SdkProvider.connect().account.toLowerCase() !== walletClient.account.address.toLowerCase()) {
        updateAccount(walletClient)
      }
    } else {
      updateAccount(walletClient)
    }
  }, [chainId, walletClient])
}

export default useGBYSDK
